import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';
import { isFuncComp } from '../../../../components/common/Helpers/index.js';

const contactInfo = Loadable(() => isFuncComp() ? import('../../FuncContainers/index') : import('../../containers/web/index'));
export default MapTo('vcg/components/soe-home/react/contactInfo')(contactInfo);
